import React, { useEffect, ReactNode } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from 'prop-types';

interface NavbarProps {
  logoSrc?: string;
  appTitle: string;
  navigations?: Array<{ path: string, title: string }>;
  children?: ReactNode;
}

class Navbar extends React.Component<NavbarProps> {
  static propTypes = {
    logoSrc: PropTypes.string,
    appTitle: PropTypes.string.isRequired,
    navigations: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      })
    ),
    children: PropTypes.node,
  }

  render() {
    const { logoSrc, appTitle, navigations, children } = this.props;

    return (
      <nav className="o-navbar">
        <div className="o-navbar__inner">
          <a className="o-navbar__brand" href="#">
            {logoSrc && (
              <img src={logoSrc} alt="" className="o-navbar__logo-svg" />
            )}
            <span className="o-navbar__app-title">{appTitle}</span>
          </a>
          <ul className="o-navbar__primary-nav-list">
            {navigations &&
              navigations.map((navItem) => (
                <li className="o-navbar__nav-item" key={navItem.path}>
                  <NavLink to={navItem.path} className="o-navbar__nav-item-link">
                    {navItem.title}
                  </NavLink>
                </li>
              ))}
          </ul>
          <div className="o-navbar__right">
            {children}
          </div>
        </div>
      </nav>
    );
  }
}
//useEffect(() => { });
export default Navbar;
